'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = React.PropTypes;

var Text = function (_React$Component) {
  _inherits(Text, _React$Component);

  function Text() {
    _classCallCheck(this, Text);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Text.prototype.render = function render() {
    var classNames = [];

    if (this.props.size) {
      classNames.push('cf-text--' + this.props.size);
    }

    if (this.props.align) {
      classNames.push('cf-text--' + this.props.align);
    }

    if (this.props.type) {
      classNames.push('cf-text--' + this.props.type);
    }

    if (this.props.case) {
      classNames.push('cf-text--' + this.props.case);
    }

    return React.createElement(
      'div',
      { className: classNames.join(' ') },
      this.props.children
    );
  };

  return Text;
}(React.Component);

Text.propTypes = {
  size: PropTypes.oneOf(['normal', 'small']),
  align: PropTypes.oneOf(['start', 'center', 'justify', 'end']),
  type: PropTypes.oneOf(['info', 'success', 'warning', 'error', 'muted']),
  case: PropTypes.oneOf(['capitalize', 'titlecase', 'lowercase', 'uppercase'])
};


module.exports = Text;